import React from 'react';
import { Flex, Heading, Text } from '@chakra-ui/react';
import Card from '#coreComponents/Card';
import lampSvg from '../images/lamp.svg';
import contentJson from '../utils/content.json';
import { useResponsive } from '#core/SdgQuiz/utils';

const content: any = contentJson;

type RelevanceProps = {
  percentage: number;
};

export const Relevance = ({ percentage }: RelevanceProps) => {
  const isMobileScreen = useResponsive();

  const { relevancePercentages, finalRelevance } = content;

  let relevance;

  if (percentage <= relevancePercentages.low) {
    relevance = finalRelevance.notRelevant;
  }

  if (
    percentage > relevancePercentages.low &&
    percentage <= relevancePercentages.medium
  ) {
    relevance = finalRelevance.partialRelevant;
  }

  if (percentage > relevancePercentages.medium) {
    relevance = finalRelevance.relevant;
  }

  return (
    <Flex>
      <Card
        px={isMobileScreen ? 3 : 7}
        bg={`rgba(${relevance.itemColor}, 0.1)`}
        mt={3}
        w="100%"
        maxW="40rem"
        borderRadius="1rem"
      >
        <Flex>
          <Flex
            bgImage={`url('${lampSvg}')`}
            bgPosition="center"
            bgSize="contain"
            bgRepeat="no-repeat"
            w="6rem"
            h="2.5rem"
            mr="0.5rem"
            minW="2rem"
          />

          <Flex flexDir="column">
            <Heading
              as="h2"
              mb="0.5rem"
              fontSize={isMobileScreen ? 'md' : 'lg'}
              color={`rgba(${relevance.itemColor}, 1)`}
            >
              {relevance.itemTitle}
            </Heading>

            <Text color="gray.600" fontSize={isMobileScreen ? 'xs' : 'sm'}>
              {relevance.itemDescription}
            </Text>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};
